import ListWithTitle from '@jobseeker/feature-job/components/ListWithTitle';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

interface ListWithTitleProp {
  onLoadMore: () => void;
  routeToJobDetail: (jobSlug: string, jobId: string | number) => void;
  title: string;
  feedOnly: boolean;
}

const ListWithTitleHarness = ({
  onLoadMore,
  routeToJobDetail,
  title,
  ...props
}: ListWithTitleProp | any) => {
  const interceptor: any = useInterceptor();

  const {
    jobfeed: {jobInfoKeyElements},
  } = interceptor;

  return (
    <ListWithTitle
      routeToJobDetail={routeToJobDetail}
      onLoadMore={onLoadMore}
      jobInfoKeyElements={jobInfoKeyElements}
      title={title}
      {...props}
    />
  );
};

export default ListWithTitleHarness;
